import {Component} from '@angular/core';
import {AnalyticsTracker} from '../../utils/AnalyticsTracker';

@Component({
    selector: 'app-common-invest-sections',
    templateUrl: './common-invest-sections.component.html',
    styleUrls: ['../home/invest.component.css', '../../../assets/styles/new-styles.css']
})

export class CommonInvestSectionsComponent {
    constructor(public analyticsTracker: AnalyticsTracker) {
    }

}
